function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group 2");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Hoivakotiportaali",
  strokeWidth: 1,
  fillRule: "evenodd",
  strokeLinecap: "square"
}, React.createElement("g", {
  id: "Hoivakotilistaus---location-select",
  transform: "translate(-207.000000, -149.000000)",
  strokeWidth: 2
}, React.createElement("g", {
  id: "List-header",
  transform: "translate(-64.000000, 115.000000)"
}, React.createElement("g", {
  id: "Filters",
  transform: "translate(0.000000, 20.000000)"
}, React.createElement("g", {
  id: "Sijainti",
  transform: "translate(79.000000, 0.000000)"
}, React.createElement("g", {
  id: "Group-2",
  transform: "translate(192.500000, 15.000000)"
}, React.createElement("line", {
  x1: 1.16666667,
  y1: 1.16666667,
  x2: 7,
  y2: 7,
  id: "Line-4"
}), React.createElement("line", {
  x1: 8.16666667,
  y1: 1.16666667,
  x2: 14,
  y2: 7,
  id: "Line-4",
  transform: "translate(10.500000, 3.500000) scale(-1, 1) translate(-10.500000, -3.500000) "
})))))));

var SvgCaret = function SvgCaret(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "15px",
    height: "10px",
    viewBox: "0 0 15 10",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCaret, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Caret.53a7ee3f.svg";
export { ForwardRef as ReactComponent };